import * as React from "react";
const SVGComponent = ({color='black', height=24, width=24, ...props}:any) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8 12.25C8.27614 12.25 8.5 12.0261 8.5 11.75C8.5 11.4739 8.27614 11.25 8 11.25C7.72386 11.25 7.5 11.4739 7.5 11.75C7.5 12.0261 7.72386 12.25 8 12.25Z"
      fill="#262626"
    />
    <path
      d="M8 9.5V9C9.10438 9 10 8.21625 10 7.25C10 6.28375 9.10438 5.5 8 5.5C6.89562 5.5 6 6.28375 6 7.25V7.5"
      stroke="#262626"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 14.5C11.3137 14.5 14 11.8137 14 8.5C14 5.18629 11.3137 2.5 8 2.5C4.68629 2.5 2 5.18629 2 8.5C2 11.8137 4.68629 14.5 8 14.5Z"
      stroke="#262626"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SVGComponent;
